import React, { Fragment, useCallback, useState } from 'react';
import { Breakpoint } from '@philips-internal/oswald-ui-constants';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, getBreakpoint } from '@philips-internal/oswald-ui-utils';
import { ContextMenu } from '../../context-menu/context-menu.js';
import { Option } from '../../option/option.js';
import { NotificationCenterClickType } from '../notification-center-constants.js';
import './notification-center-item.css';
const isMobileSize = () => {
    const breakpoint = getBreakpoint();
    return breakpoint === Breakpoint.SM || breakpoint === Breakpoint.XSM;
};
function NotificationCenterItem(props) {
    const [showContextMenu, setShowContextMenu] = useState(isMobileSize());
    const { canDeleteNotification, canMarkAsRead, canMarkAsUnread, date, description, id, image, onItemClick, read, time, title, type, uuid } = props;
    const item = { date, description, id, read, time, title, type };
    const key = id;
    const menuOptions = [];
    if (canMarkAsRead && !read) {
        menuOptions.push({
            action: () => onItemClick(item, NotificationCenterClickType.MARK_AS_READ),
            expression: 'tws.notification-center.mark-as-read',
        });
    }
    if (canMarkAsUnread && read) {
        menuOptions.push({
            action: () => onItemClick(item, NotificationCenterClickType.MARK_AS_UNREAD),
            expression: 'tws.notification-center.mark-as-unread',
        });
    }
    if (canDeleteNotification) {
        menuOptions.push({
            action: () => onItemClick(item, NotificationCenterClickType.DELETE),
            expression: 'tws.notification-center.delete-notification',
        });
    }
    const renderOptions = useCallback(() => {
        return (React.createElement(Fragment, null, menuOptions.map((option) => (React.createElement(Option, { enabled: true, key: option.expression, onClick: option.action, preventDefault: true, stopPropagation: false, value: option.expression })))));
    }, []);
    const getClassNameWrapper = useCallback(() => {
        return classNames({
            'c-notification-center-item__read': !read,
            'c-notification-center-item__without-type': !type,
            'c-notification-center-item__wrapper': true,
        });
    }, [read, type]);
    const getClassNameTitle = useCallback(() => {
        return classNames({ 'c-notification-center-item__header-title': !read });
    }, [read]);
    const getClassNameBullet = useCallback(() => {
        return classNames({
            'c-notification-center-item__read-bullet': true,
            'c-notification-center-item__read-bullet-img': Boolean(image),
        });
    }, [image]);
    const unreadBullet = !read ? React.createElement("div", { className: getClassNameBullet() }) : null;
    const renderImage = image ? React.createElement("img", { className: "c-notification-center-item__image", src: image }) : null;
    const hasAvailableOptions = canMarkAsRead || canDeleteNotification;
    return (React.createElement("div", { className: getClassNameWrapper(), key: key, onMouseLeave: () => setShowContextMenu(false), onMouseOver: () => setShowContextMenu(true) },
        React.createElement("div", { className: "c-notification-center-item__card-notification", onClick: () => onItemClick(item, NotificationCenterClickType.NOTIFICATION_CLICK) },
            unreadBullet,
            renderImage,
            React.createElement("div", { className: "c-notification-center-item" },
                React.createElement("div", { className: "c-notification-center-item__header" },
                    React.createElement("div", { className: getClassNameTitle() }, title)),
                React.createElement("div", { className: "c-notification-center-item__body" }, description),
                React.createElement("div", { className: "c-notification-center-item__header-date" }, MessageService.translate(time)))),
        React.createElement("div", { className: "c-notification-center-item__context-menu" }, showContextMenu && hasAvailableOptions
            ? (React.createElement(ContextMenu, { uuid: uuid }, renderOptions()))
            : null)));
}
export { NotificationCenterItem, };
//# sourceMappingURL=notification-center-item.js.map